import { create } from 'zustand'
import { jwtDecode } from 'jwt-decode'

interface OdinState {
  isAuthenticated: boolean
  idToken?: string
  idTokenDecoded?: Record<string, string | number | boolean>
  initialized: boolean
  authUrl: string
  goToAuth: (action: 'sign-in' | 'sign-up', redirectUrl?: string) => void
  setAuthenticated: (idToken: string) => void
  setInitialized: () => void
  setAuthUrl: (url: string) => void
  resetAuth: () => void
}

export const useOdinStore = create<OdinState>((set, get) => ({
  isAuthenticated: false,
  idTokenDecoded: undefined,
  initialized: false,
  authUrl: '',

  setAuthenticated: (idToken: string) => {
    set({
      isAuthenticated: true,
      idToken,
      idTokenDecoded: jwtDecode(idToken) as Record<string, string | number | boolean>,
    })
  },

  setInitialized: () => set({ initialized: true }),

  setAuthUrl: (url: string) => set({ authUrl: url }),

  resetAuth: () => set({ isAuthenticated: false, idToken: undefined, idTokenDecoded: undefined }),

  goToAuth: (action, redirectUrl) => {
    const { authUrl } = get()
    const params = new URLSearchParams({ action })
    if (redirectUrl) params.set('redirectUrl', redirectUrl)
    window.location.href = `${authUrl}?${params.toString()}`
  },
}))
